module.exports = require("npm:swiper@4.1.0/dist/js/swiper.js");